import getRougeRewards from 'services/api/beautyInsider';
import {
    UPDATE_ROUGE_EXCLUSIVE_REWARDS,
    SHOW_ROUGE_REWARD_LEARN_MORE_MODAL,
    HIDE_ROUGE_REWARD_LEARN_MORE_MODAL
} from 'constants/actionTypes/rougeRewards';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import promoUtils from 'utils/Promos';
import Actions from 'actions/Actions';

const updateRougeExclusiveRewards = (profileLanguage, profileLocale) => (dispatch, getState) => {
    getRougeRewards.getRougeRewards(profileLanguage, profileLocale).then(data => {
        const basket = getState().basket;
        const updatedRewards = rougeExclusiveUtils.updateRougeExclusiveSkus(data.biRewards, basket);

        dispatch({
            type: UPDATE_ROUGE_EXCLUSIVE_REWARDS,
            payload: updatedRewards
        });
    });
};

const loadRougeRewards = (profileLanguage, profileLocale) => dispatch => {
    if (!rougeExclusiveUtils.isRougeExclusive()) {
        return;
    }

    dispatch(updateRougeExclusiveRewards(profileLanguage, profileLocale));
};

/**
 * Apply a Rouge Cash Reward coupon to the basket
 * @param {string} couponCode - The coupon code to apply
 * @returns {Function} Redux thunk action
 */
export const applyRougeCashReward = (couponCode) => () => {
    return promoUtils.applyPromo(couponCode.toLowerCase(), null, promoUtils.CTA_TYPES.RRC);
};

/**
 * Remove a Rouge Cash Reward coupon from the basket
 * @param {string} couponCode - The coupon code to remove
 * @returns {Function} Redux thunk action
 */
export const removeRougeCashReward = (couponCode) => () => {
    return promoUtils.removePromo(couponCode.toLowerCase(), promoUtils.CTA_TYPES.RRC);
};

/**
 * Show the Rouge Reward Learn More modal
 * @param {Object} coupon - Coupon object containing couponCode, denomination, expirationDate
 * @returns {Function} Redux thunk action
 */
export const showRougeRewardLearnMoreModal = (coupon) => (dispatch) => {
    dispatch({
        type: SHOW_ROUGE_REWARD_LEARN_MORE_MODAL,
        payload: coupon
    });
};

/**
 * Hide the Rouge Reward Learn More modal
 * @returns {Function} Redux thunk action
 */
export const hideRougeRewardLearnMoreModal = () => (dispatch) => {
    dispatch({
        type: HIDE_ROUGE_REWARD_LEARN_MORE_MODAL
    });
};

/**
 * Show error modal for Rouge Rewards operations
 * @param {Object} params - Error modal parameters
 * @param {string} params.title - Modal title
 * @param {string} params.message - Error message
 * @param {string} params.buttonText - Button text
 * @returns {Function} Redux thunk action
 */
export const showRougeRewardsErrorModal = ({ title, message, buttonText }) => (dispatch) => {
    dispatch(Actions.showInfoModal({
        isOpen: true,
        title,
        message,
        buttonText
    }));
};

export default {
    loadRougeRewards
};
